var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"img-view",on:{"click":_vm.bigImg}},[_c('div',{staticClass:"img-layer"}),_c('div',[_c('img',{staticClass:"img",attrs:{"src":_vm.imgSrc}})])])}
var staticRenderFns = []

export { render, staticRenderFns }